import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHAgrupamientoIns = async (credentials, data) => {
  const body = {
    service: "RNHAgrupamientoIns",
    params: {
      rnhAgrupamientoCod: data?.cod || null,
      rnhAgrupamientoNombre: data?.nombre || null
    },
  };
  return respuestaDe(await axiosPost(body, credentials));

};
